<template>
  <div id="infobits-app" tabindex="-1" @keydown="key" @keyup="key">
    <toolbar></toolbar>
    <infobits-content></infobits-content>
  </div>
</template>

<script>
export default {

  mounted () {
    this.$el.focus()
  },

  methods: {
    key (e) {
      this.$store.dispatch('setModKeys', {
        shiftKey: e.shiftKey,
        altKey:   e.altKey
      })
    }
  },

  components: {
    'toolbar':          require('./toolbar.vue'),
    'infobits-content': require('./infobits-content.vue')
  }
}
</script>

<style src="font-awesome/css/font-awesome.css"></style>
<style>
@import url('https://fonts.googleapis.com/css?family=Arvo');
</style>
<style>

:root {
  --main-font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  --main-font-size: 14px;
  --small-font-size: 12px;
  --panel-title-font-size: 18px;
  --logo-font-family: Arvo, serif;
  --hotspot-color: #107090;             /* Color of clickable elements. Matches standard infobit color (see typedefs) */
  --hotspot-hover-color: #0cf;          /* Color of clickable elements when hovered */
  --grey-border: #dbdbdb;               /* Color of divider lines and button borders */
  --standard-text-color: #333;          /* Color of standard text on screen **/
  --toolbar-color: #4b6e86;             /* Color of the toolbar background */
  --toolbar-text-color: #bde;           /* Color of the text in the toolbar */
  --detail-panel-color: #f6fbff;        /* Color of the detail panel background */
  --tree-panel-color: #fdfeff;          /* Color of the tree panel background */
  --inbox-panel-color: #f6fbff;         /* Color of the inbox panel background */
  --search-match-color: #d8eefc;        /* Color of tree panel infobits that match the search term */
  --transclusion-color: #f0f8fe;        /* Color of tree branches that are transclusions */
  --infobit-hover-color: rgba(0, 0, 0, 0.05);   /* Background color of infobit when hovered */
  --infobit-padding-top: 0.3em;         /* Space above an infobit (in tree and inbox) */
  --infobit-padding-bottom: 0.2em;      /* Space below an infobit (in tree and inbox) */
  --infobit-list-spacing: 0.3em;        /* Vertical space between infobits (in tree and inbox) */
  --horizontal-panel-padding: 1.5em;    /* left and right padding of the 3 panels */
}

html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
  overflow: hidden;       /* avoid window bounce when scrolling reaches top/bottom */
  word-wrap: break-word;  /* avoid horizontal scrollbar in case of very long words */
  font-family: var(--main-font-family);
  font-size: var(--main-font-size);
  color: var(--standard-text-color);
}

input {
  font-family: var(--main-font-family);
  font-size: var(--main-font-size);
  background-color: transparent;
  border-width: 0px 0px 1px 0px;
  border-color: var(--grey-border);
  border-style: solid;
}

button, input[type="submit"], input[type="file"] {
  font-family: var(--main-font-family);
  font-size: var(--main-font-size);
  background-color: transparent;
  border-width: 0;
  margin: 0;
  padding: 0;
}

button:disabled {
  opacity: 0.3;
}

select {
  font-family: var(--main-font-family);
  font-size: var(--main-font-size);
  background-color: transparent;
  border-color: var(--grey-border);
}

#app {
  height: 100%;
}

#infobits-app {
  height: 100%;
  display: flex;
  flex-flow: column;
}

.label {
  font-size: var(--small-font-size);
  color: gray;
}

.panel-title {
  font-size: var(--panel-title-font-size);
  font-weight: bold;
  margin-top: 2em;
  margin-bottom: 1em;
}

.horizontal-divider {
  border-bottom: 1px solid var(--grey-border);
}

.highlight {
  background-color: yellow;
}

.clickable {
  color: var(--hotspot-color);
}

.clickable:hover {
  color: var(--hotspot-hover-color) !important;
  cursor: pointer;
}

.hoverable:hover {
  color: var(--hotspot-hover-color) !important;
  cursor: pointer;
}

.pointable:hover {
  cursor: pointer;
}

.debug {
  font-size: 75%;
  color: gray;
}
</style>



// WEBPACK FOOTER //
// infobits-app.vue?77885633